import { Injectable } from "@angular/core";
import { BaseCrudService } from "src/app/services/apps/generic/base.service";
import {
  ISaleOrderGetDTO,
  ISaleOrderCreateDTO,
  ISaleOrderUpdateDTO,
} from "./models";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SaleOrderService extends BaseCrudService<
  ISaleOrderGetDTO,
  ISaleOrderCreateDTO,
  ISaleOrderUpdateDTO,
  string
> {
  constructor() {
    super(environment.endpoints.orders.salesOrders);
  }
}
